import type { CSSProperties } from 'react';

import { classnames } from '@/helpers';

type BrandProductImageSize = 'sm' | 'lg' | 'scale';

const FRAME_SIZE: { [key in BrandProductImageSize]: CSSProperties } = {
  lg: { width: 72, height: 124 },
  sm: { width: 40, height: 70 },
  scale: {
    width: 'clamp(40px, calc(40px + (100cqw - 320px) * 32 / 416), 72px)',
    height: 'clamp(70px, calc(70px + (100cqw - 320px) * 54 / 416), 124px)',
  },
};

export const BrandProductImage = ({
  size,
  imgSrc,
  className = '',
}: {
  size: BrandProductImageSize;
  imgSrc: string;
  className?: string;
}) => {
  return (
    <div
      className={classnames(
        className,
        'pt-xs pb-sm px-[5px]',
        'bg-[linear-gradient(to_bottom,var(--color-bg-secondary)_70%,var(--color-bg-secondary-bold)_30%)]',
        'border-border_regular flex flex-shrink-0 items-end justify-around rounded-full border',
      )}
      style={FRAME_SIZE[size]}>
      <img className="max-h-full max-w-full object-contain" src={imgSrc} />
    </div>
  );
};
